import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getPinRevisions, revertPinToRevision, getPin } from '../../actions/pins';
import Moment from 'react-moment';
import Markup from 'interweave';

const PinHistory = ({ pinId, pin, auth, getPinRevisions, revertPinToRevision, getPin, onClose, onRevertClose }) => {
  const [revisions, setRevisions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!pinId) return;
    setLoading(true);
    getPinRevisions(pinId)
      .then((res) => {
        if (res && res.data) {
          setRevisions(res.data);
          setSelected((res.data && res.data[0]) || null);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [pinId, getPinRevisions]);

  useEffect(() => {
    if (pin && pin.revisions) {
      if (!revisions || revisions.length === 0) {
        setRevisions(pin.revisions);
        setSelected((pin.revisions && pin.revisions[0]) || null);
      }
    }
  }, [pin]);

  const onSelect = (rev) => setSelected(rev);
  const isOwner = auth && auth.user && pin && auth.user.id === pin.owner;

  const onRevert = () => {
    if (!selected || !isOwner) return;
    revertPinToRevision(pinId, selected.id).then(() => {
      getPin(pinId);
      if (onClose) onClose();
      if (onRevertClose) onRevertClose();
    });
  };

  if (!pinId) return null;

  return (
    <div className="pin-history">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div>
            <div style={{ color: 'var(--gray)', fontSize: '1.25rem', fontWeight: 600 }}>{pin && pin.title}</div>
          </div>
          <div>
            <button
              onClick={() => onClose && onClose()}
              aria-label="Close history"
              className="btn btn-sm"
              style={{ padding: 0, color: 'var(--purple)', border: 'none', background: 'transparent', fontSize: '2rem', lineHeight: 1 }}
            >
              ×
            </button>
          </div>
        </div>
        <div className="card-body">
          {loading && <div className="text-muted">Loading revisions…</div>}
          <div className="d-flex" style={{ gap: 16 }}>
            <div style={{ width: 300 }}>
              {((revisions || []).length === 0 && !loading) && <div className="text-muted">No revisions found.</div>}
              <ul className="list-group">
                {(revisions || []).map((rev, idx) => {
                  const isActive = selected && selected.id === rev.id;
                  const defaultLabel = `Revision ${revisions ? (revisions.length - idx) : rev.id}`;
                  return (
                    <li
                      key={rev.id}
                      className={`list-group-item ${isActive ? 'active' : ''}`}
                      style={{ backgroundColor: isActive ? 'var(--purple)' : '#fff', color: isActive ? '#fff' : 'var(--gray)' }}
                    >
                      <button onClick={() => onSelect(rev)} className="btn p-0 text-start" style={{ width: '100%', color: isActive ? '#fff' : 'var(--gray)' }}>
                        <div className="fw-semibold">{rev.summary || defaultLabel}</div>
                        <div className="small" style={{ color: isActive ? 'rgba(255,255,255,0.9)' : 'var(--gray)' }}>{rev.editor_username || 'Unknown'} · <Moment fromNow>{rev.created_at}</Moment></div>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div style={{ flex: 1 }}>
              <div className="d-flex justify-content-between mb-2">
                <div>
                  <strong>Current</strong>
                  <div className="text-muted small">Current title</div>
                </div>
                <div>
                  <strong>Selected</strong>
                  <div className="text-muted small">{selected ? selected.title : '—'}</div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="border p-3">
                    <div className="text-muted small mb-2">Current description</div>
                    <div><Markup content={pin && pin.description ? pin.description : ''} /></div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="border p-3">
                    <div className="text-muted small mb-2">Selected revision</div>
                    {selected ? (
                      <>
                        <div><Markup content={selected.description} /></div>
                        {selected.summary && <div className="text-muted small mt-2"><em>Summary:</em> {selected.summary}</div>}
                      </>
                    ) : (
                      <div className="text-muted">No revision selected</div>
                    )}
                  </div>
                </div>
              </div>
              {isOwner && (
                <div className="mt-3">
                  <button
                    className="btn btn-sm default-btn-purple"
                    onClick={onRevert}
                    disabled={!selected}
                  >
                    Revert to selected
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pin: state.pins.pin,
  auth: state.auth,
});

export default connect(mapStateToProps, { getPinRevisions, revertPinToRevision, getPin })(PinHistory);
